import { withTheme } from '@material-ui/core';
import { findLastIndex } from 'lodash-es';
import autoMergeLevel1 from 'redux-persist/es/stateReconciler/autoMergeLevel1';

const styles = (theme) => ({
  breadcrumbLink: {
    color: theme.palette.text.dark,
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  breadcrumbArrowContainer: {
    minHeight: 24,
    height: 'auto',
    display: 'inline-block',
    verticalAlign: 'bottom',
  },
  breadcrumbArrow: {
    color: theme.palette.text.dark,
    paddingTop: '1px',
    verticalAlign: 'bottom',
    [theme.breakpoints.up('md')]: {
      position: 'relative',
      top: 3,
    },
  },
  breadcrumbSpan: {
    alignItems: 'center',
    fontSize: '1rem',
    fontWeight: 500,
    [theme.breakpoints.up('sm')]: {
      fontSize: '1.125rem',
    },
    [theme.breakpoints.up('md')]: {
      fontSize: '1.25rem',
    },
  },
  crumb: {
    display: 'inline-flex',
    alignItems: 'flex-start',
    verticalAlign: 'bottom',
    [theme.breakpoints.up('md')]: {
      display: 'inline-block',
    },
  },
});

export default styles;
